// extracted by mini-css-extract-plugin
export default {"flex-center":"tabs_flex-center__VdNDD","tabs":"tabs_tabs__ZVYrr","moreEvents":"tabs_moreEvents__Hbw5M","flex-vertical-center":"tabs_flex-vertical-center__KuF8A"};